import React from 'react';
import { CURRENCY_CODES } from '@fiverr-private/localization';

export const CurrencyContext = React.createContext(CURRENCY_CODES.USD);
